<script>
  /**
   * ボタンから入力値を選択できるテキスト入力欄
   * - 候補リストがボタン表示されて、押すとボタンが消えてテキストとして入力される
   */
  import Field from './Field.svelte'
  import { scrollOnFocus } from '../../modules/scrollOnFocus'

  export let id
  export let name
  export let label
  export let list = []
  export let placeholder
  export let required
  export let isLoading = false

  export let value

  const attributes = {}

  // ボタン表示状態かどうか(入力値がまだ無くて、かつ候補リストが存在するなら、ボタン表示)
  $: isButtonMode = !value && list && list.length

  if (placeholder) attributes.placeholder = placeholder
</script>

<Field {id} {label} {isLoading}>
  <input
    class="input"
    class:cloak={isButtonMode}
    type="search"
    {id}
    {name}
    {...attributes}
    {required}
    bind:value
    data-testid={`${id}Input`}
    use:scrollOnFocus
  />

  {#if isButtonMode}
    <div class="buttons">
      {#each list as option, index}
        <button
          type="button"
          class="button is-info"
          data-testid={`${id}Button-${index}`}
          value={option}
          on:click={() => {
            value = option
          }}
          >{option}
        </button>
      {/each}
    </div>
  {/if}
</Field>

<style>
  /* データが入力されるまで 1px 幅で見えない状態にする(required チェックを効かせるため) */
  input.cloak {
    opacity: 0;
    width: 1px;
    padding: 0;
    margin: 0;
    border: 0;
    float: left; /* Reposition so the validation message shows over the label */
  }
</style>
